import { Icon20More } from '@vkontakte/icons';
import React, { type ReactNode, memo, useState } from 'react';

import styles from './FoldingOptionsList.css';

interface Props {
    children: ReactNode;
    description: string;
    open?: boolean;
}

export default memo(function FoldingOptionsList({ children, open, description }: Props) {
    const [expandSettings, setExpandSettings] = useState(!!open);

    if (expandSettings) {
        return <>{children}</>;
    }

    return (
        <div
            data-qa-id="sharing-more-options-button"
            role="button"
            onClick={() => setExpandSettings(true)}
            className={styles.moreOptionsButton}
        >
            <span className={styles.moreOptionsTitle}>
                <Icon20More />
                Больше настроек
            </span>
            <span className={styles.moreOptionsDescription}>{description}</span>
        </div>
    );
});
